import routerOptions0 from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/node_modules/.pnpm/nuxt@3.9.3_@parcel+watcher@2.5.6_@types+node@22.19.20_eslint@8.57.1_magicast@0.5.3_optionator_rpgr3alvmt35x3k45uzz4xrop4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}